import { MediaListItem } from '../models/media-list-item';

export const getMediaKey = (mediaId: number): string => `m:${mediaId}`;
export const getFileKey = (file: File): string => `f:${file.name}:${file.size}`;

export const getMediaListItemKey = (item: MediaListItem): string =>
  item.type === 'media' ? getMediaKey(item.media.id) : getFileKey(item.file);
